(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("core-api", [], factory);
	else if(typeof exports === 'object')
		exports["core-api"] = factory();
	else
		root["core-api"] = factory();
})(this, () => {
return 